import { render, staticRenderFns } from "./artistInfo.vue?vue&type=template&id=7670d076&scoped=true&"
import script from "./artistInfo.vue?vue&type=script&lang=js&"
export * from "./artistInfo.vue?vue&type=script&lang=js&"
import style0 from "./artistInfo.vue?vue&type=style&index=0&id=7670d076&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670d076",
  null
  
)

export default component.exports